const regexReplacements = [
    // GUID
    [
        /\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\/|$)/g,
        '/:guid$1',
    ],
    // Hexa ID
    [/\/[0-9a-fA-F]{24,}(\/|$)/g, '/:id$1'],
    // Numeric ID
    [/\/[0-9]{12}(\/|$)/g, '/:id$1'],
    // Date
    [/\/[0-9]{4}-[0-9]{2}-[0-9]{2}(\/|$)/g, '/:date$1'],
    // Form submission
    [/\/comp-[a-zA-Z0-9]{8}(\/|$)/g, '/:id$1'],
    // Remove trailing slash
    [/\/$/, ''],
];
export const normalizeUrl = (originalUrl) => {
    const url = new URL(originalUrl);
    regexReplacements.forEach(([regex, replacement]) => {
        url.pathname = url.pathname.replace(regex, replacement);
    });
    url.search = '';
    return url.toString();
};
//# sourceMappingURL=url.js.map